module.exports = __webpack_public_path__ + "static/media/Certifcats2000w_big.02d5685b.webp";